import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { useId, type ReactNode } from 'react';

export function Checkbox({ label, checked, onCheckedChange, disabled }: { label: ReactNode; checked: boolean; onCheckedChange: (checked: boolean) => void; disabled?: boolean }) {
  const id = useId();
  return (
    <span className="bb-choice">
      <CheckboxPrimitive.Root id={id} className="bb-checkbox" checked={checked} disabled={disabled} onCheckedChange={(v) => onCheckedChange(v === true)}>
        <CheckboxPrimitive.Indicator aria-hidden="true">✓</CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <label htmlFor={id}>{label}</label>
    </span>
  );
}

export function Switch({ label, checked, onCheckedChange, disabled }: { label: ReactNode; checked: boolean; onCheckedChange: (checked: boolean) => void; disabled?: boolean }) {
  const id = useId();
  return (
    <span className="bb-choice">
      <SwitchPrimitive.Root id={id} className="bb-switch" checked={checked} disabled={disabled} onCheckedChange={onCheckedChange}>
        <SwitchPrimitive.Thumb className="bb-switch__thumb" />
      </SwitchPrimitive.Root>
      <label htmlFor={id}>{label}</label>
    </span>
  );
}

export interface RadioOption {
  value: string;
  label: ReactNode;
  disabled?: boolean;
}

export function RadioGroup({ label, options, value, onValueChange }: { label: string; options: RadioOption[]; value: string; onValueChange: (value: string) => void }) {
  const id = useId();
  return (
    <RadioGroupPrimitive.Root aria-label={label} value={value} onValueChange={onValueChange} className="bb-field">
      {options.map((option) => (
        <span key={option.value} className="bb-choice">
          <RadioGroupPrimitive.Item id={`${id}-${option.value}`} value={option.value} disabled={option.disabled} className="bb-radio">
            <RadioGroupPrimitive.Indicator aria-hidden="true">•</RadioGroupPrimitive.Indicator>
          </RadioGroupPrimitive.Item>
          <label htmlFor={`${id}-${option.value}`}>{option.label}</label>
        </span>
      ))}
    </RadioGroupPrimitive.Root>
  );
}
